import React from 'react';
import SVG from 'react-inlinesvg';

export function CardHeader({
  title,
  subtitle,
  onPreIconClick,
  iconPath = '',
  preIconPath = '',
  iconClasses = '',
  preIconClasses = '',
  btn,
}) {
  return (
    <div className="card-header d-flex justify-content-between card-header-bg">
      <div className="d-block">
        {iconPath ? (
          <>
            <div className="d-flex align-items-center">
              {preIconPath && (
                <span
                  className={`${preIconClasses} svg-icon mr-3`}
                  onClick={onPreIconClick}
                >
                  <SVG cacheRequests uniquifyIDs src={preIconPath} />
                </span>
              )}
              <span className={`${iconClasses} svg-icon mr-2`}>
                <SVG cacheRequests uniquifyIDs src={iconPath} />
              </span>
              <div className="ml-2">
                <h4 className="m-0 title"> {title} </h4>
                <span className="sub-title"> {subtitle} </span>
              </div>
            </div>
          </>
        ) : (
          <>
            <h4 className="m-0 title" style={{ minHeight: 21 }}>
              {' '}
              {title}{' '}
            </h4>
            <span className="sub-title"> {subtitle} </span>
          </>
        )}
      </div>
      {btn ? (
        <div className="d-flex justify-content-end align-items-center">
          {btn}
        </div>
      ) : null}
    </div>
  );
}
